import Button from 'common/components/button'

type Props = {
  disabled: boolean
  onCancel: () => void
  onAdd: () => void
}

const ImagesGalleryModalFooter = ({ onCancel, onAdd, disabled }: Props) => {
  return (
    <div className="w-full flex justify-end mt-8">
      <Button variant="link" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant="primary"
        className="ml-4"
        onClick={onAdd}
        disabled={disabled}
      >
        Add
      </Button>
    </div>
  )
}

export default ImagesGalleryModalFooter
